export enum NudgeType {
  CTA = 'CTA',
  CALLOUT = 'CALLOUT',
}

export const NUDGE_EXPIRATION_TIME = 24 * 60 * 60 * 1000; // 24 hours in milliseconds
